/* ****************************************
Enqueue thy scripts in here
**************************************** */

document.addEventListener('DOMContentLoaded', function () {
    var headers = document.querySelectorAll('.accordion-header');
    var bodies = document.querySelectorAll('.accordion-body');

    // Initially collapse all accordion bodies
    bodies.forEach(function (body) {
        body.style.display = 'none';
    });

    /* Open the first item by default
    if (headers.length > 0 && bodies.length > 0) {
        headers[0].classList.remove('collapsed');
        headers[0].setAttribute('aria-expanded', 'true');
        headers[0].querySelector('.accordion-button').classList.add('active');
        bodies[0].style.display = 'block';
    }
        */

    // Add click event listener to each header
    headers.forEach(function (header, index) {
        header.addEventListener('click', function () {
            // Collapse all bodies
            bodies.forEach(function (body, bodyIndex) {
                if (bodyIndex !== index) {
                    body.style.display = 'none';
                    headers[bodyIndex].classList.add('collapsed');
                    headers[bodyIndex].setAttribute('aria-expanded', 'false');
                    headers[bodyIndex].querySelector('.accordion-button').classList.remove('active');
                }
            });

            // Toggle the display of the clicked header's body
            var nextElem = header.nextElementSibling;
            while (nextElem && !nextElem.classList.contains('accordion-body')) {
                nextElem = nextElem.nextElementSibling;
            }

            if (nextElem && nextElem.style.display === 'none') {
                nextElem.style.display = 'block';
                header.classList.remove('collapsed');
                header.setAttribute('aria-expanded', 'true');
                header.querySelector('.accordion-button').classList.add('active');
            } else if (nextElem) {
                nextElem.style.display = 'none';
                header.classList.add('collapsed');
                header.setAttribute('aria-expanded', 'false');
                header.querySelector('.accordion-button').classList.remove('active');
            }
        });
    });
});
